__turbopack_context__.v({
  "box": "Checkbox-module__LP4YHa__box",
  "checkbox": "Checkbox-module__LP4YHa__checkbox",
  "checked": "Checkbox-module__LP4YHa__checked",
  "disabled": "Checkbox-module__LP4YHa__disabled",
  "error": "Checkbox-module__LP4YHa__error",
  "input": "Checkbox-module__LP4YHa__input",
  "label": "Checkbox-module__LP4YHa__label",
  "noLabel": "Checkbox-module__LP4YHa__noLabel",
  "radio": "Checkbox-module__LP4YHa__radio",
});
